const enLang = {
  header: {
    setting: 'Set up',
    fullScreen: 'Full screen',
    exitFullscreen: 'Exit Full Screen',
    userCenter: 'Personal Center',
    logout: 'Sign out',
    langLabel: 'language',
    zhTip: 'Chinese',
    enTip: 'English',
  },
  button: {
    searchText: 'Search'
  },
}

export default enLang
